import React from "react";
import Header from "./components/Header";
import Fooder from "./components/Fooder";
import General from "./components/General";
import Past from "./components/Past";
import Documentation from "./components/Documentation";
import { supabase } from "./supabaseClient";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      loading: true,
      error: null,
    };
  }

  async componentDidMount() {
    try {
      // ⚠️ Впиши сюда ТОЧНОЕ имя твоей таблицы в Supabase
      // Например: "Список"
      const { data, error } = await supabase
        .from("List")
        .select("*");

      if (error) throw error;

      // Если хочешь сортировку (например, по created_at или по id/uuid) — добавим позже
      this.setState({
        items: data || [],
        loading: false,
      });
    } catch (e) {
      this.setState({
        error: e.message,
        loading: false,
      });
    }
  }

  render(){
    return (
      <div className="wrapper">
        <Header/>
        <General items={this.state.items}/>
        <Documentation/>
        <Past items={this.state.items}/>
        <Fooder/>
      </div>
    );
  }
}

export default App;
